import { ButtonStylesParams } from '@mantine/core';
import { MantineThemeComponent } from '../../types';

const DEFAULT_FONT_SIZE = 16;
const BUTTON_FONT_SIZES = {
	xs: 12,
	sm: 14,
	md: 16,
	lg: 16
};

const isSmall = ( size?: string | number ) => [ 'xs', 'sm' ].includes( size?.toString() || '' );
const fontSizeForSize = ( size?: string | number ) => (
	BUTTON_FONT_SIZES[ size?.toString() as keyof typeof BUTTON_FONT_SIZES ] || DEFAULT_FONT_SIZE
);

const ButtonDefaultConfig: MantineThemeComponent = {
	defaultProps: {
		variant: 'filled',
		size: 'md',
		loaderProps: {
			size: 'xs'
		}
	},
	styles: ( _theme, _params: ButtonStylesParams, { size } ) => ( {
		root: {
			height: isSmall( size ) ? 30 : 40,
			fontSize: fontSizeForSize( size )
		}
	} )
};

export default ButtonDefaultConfig;
